<script setup lang="ts">
  import {defineProps} from "vue";
  const props =defineProps({ roomSpec: Array })
  const commoditiesList = [
    {
      label: 'Wifi',
      icon: 'fa fa-wifi fa-2x',
      desc: 'Un wifi haut débit pour rester connecté.',
    },
    {
      label: 'Double chambre',
      icon: 'fa fa-door-closed fa-2x',
      desc: 'Deux chambres bien équipés.',
    },
    {
      label: 'Cuisine Moderne équipé',
      icon: 'fa fa-dumpster fa-2x',
      desc: 'Une Cuisine avec toutes les commodités.',
    },
    {
      label: 'Chauffe eau',
      icon: 'fa fa-wifi fa-2x',
      desc: 'Une Douche équipé d\'un de système de chauffe eau .',
    },
    {
      label: 'Tv',
      icon: 'fa fa-tv fa-2x',
      desc: 'Un écran Tv Plasma avec abonnement canal +.',
    },
    {
      label: 'Climatisation',
      icon: 'fa fa-fan fa-2x',
      desc: 'Une climatisation fonctionnel.',
    },
    {
      label: '2 Tv',
      icon: 'fa fa-tv fa-2x',
      desc: 'Deux écrans Tv Plasma pour chaque pièce avec abonnement canal +.',
    },
    {
      label: 'Deux douche',
      icon: 'fa fa-bathtub fa-2x',
      desc: 'Deux douches de haut standing pour chaque chambre avec toutes les commodités.',
    },
    {
      label: 'Une douche',
      icon: 'fa fa-bathtub fa-2x',
      desc: 'Une douches de haut standing avec toutes les commodités.',
    },
    {
      label: 'Salle de gym',
      icon: 'fa-heart fa-2x',
      desc: 'Un accès gratuit à une salle de gymnase bien équipée.',
    },
    {
      label: 'Petit-déjeuner',
      icon: 'fa fa-coffee fa-2x',
      desc: 'Un petit déjeuner offer.',
    },
    {
      label: 'Salle de jeu',
      icon: 'fa fa-child fa-2x',
      desc: 'Un espace pour les tout petit.',
    },
  ]
  const commodChoose = commoditiesList.filter(comm => props.roomSpec?.includes(comm.label))
</script>

<template>
  <ul class="uk-child-width-1-3@xl uk-child-width-1-3@l uk-child-width-1-2@m uk-child-width-1-2@s uk-grid-medium uk-grid-match" data-uk-grid>
    <li class="uk-text-center"
        v-for="(item, idx) in commodChoose.slice(0, 6)"
        :key="idx">
      <div class="uk-card uk-card-default uk-card-body impx-padding-medium">
        <!-- highlight item -->
        <i :class="item.icon + ' impx-text-csa'"></i>
        <h6 class="uk-margin-remove-bottom uk-margin-small-top">{{ item.label }}</h6>
        <p class="uk-margin-remove-bottom uk-margin-small-top">
          {{ item.desc }}
        </p>
      </div>
    </li>
  </ul>
</template>

<style scoped>

</style>